import { Grid } from 'src/components/grid'
import Button from '@hotmart/space-lib/dist/components/button'
import i18n from 'src/i18n'
import {
  ContainerSidebar,
  ContainerSidebarContent,
  ContainerSidebarFooter,
  CustomSidebar,
  CustomSidebarHeader
} from 'src/pages/CommunityDetails/PostModalPublication/components/postSidebarFull/postSidebarFull.styles'
import { PostModalHeader } from 'src/pages/CommunityDetails/PostModalPublication'
import { PostModalFooterContainer } from 'src/pages/CommunityDetails/PostModalPublication/components/postModalFooter/postModalFooter.styles'
import { PostMediaContainer } from 'src/components/postCard/components/postMediaContainer'
import { EditPostModalContent } from '../editPostModalContent'
import { PostModalSidebarProps } from '../../editPost.types'

const EditPostSidebar = ({
  isOpen,
  onClose,
  post,
  title,
  setTitle,
  description,
  setDescription,
  mentions,
  showPostMediaContainer,
  submitAction,
  isLoading,
  isDisabled,
  handleModalFullScreen
}: PostModalSidebarProps) => (
  <CustomSidebar isOpen={isOpen} onClose={onClose}>
    <ContainerSidebar className="_vw-full _vh-full _overflow-y-auto _overflow-x-hidden">
      <CustomSidebarHeader className="_d-flex _justify-content-start _vw-full _border-bottom _border-gray-200">
        <PostModalHeader
          handleOnClose={onClose}
          handleModalFullScreen={handleModalFullScreen}
          className="_w-full"
          isFullScreen
        />
      </CustomSidebarHeader>

      <div className="_d-flex _flex-column _justify-content-start align-items-start _vw-full">
        <ContainerSidebarContent className="_w-full _v-full _position-relative _overflow-x-hidden _pt-6">
          <Grid.Row>
            <Grid.Col
              xs={{ offset: 1, size: 10 }}
              md={{ offset: 2, size: 8 }}
              lg={{ offset: 2, size: 8 }}
              id="post-content-container"
            >
              <EditPostModalContent
                title={title}
                postType={post.postType}
                setTitle={setTitle}
                description={description}
                setDescription={setDescription}
                mentions={mentions}
                isFullScreen
              />
              {showPostMediaContainer && <PostMediaContainer post={post} isEdit />}
            </Grid.Col>
          </Grid.Row>
        </ContainerSidebarContent>
      </div>

      <ContainerSidebarFooter className="_d-flex _flex-column _justify-content-center align-items-start">
        <PostModalFooterContainer
          $isFullscreen={true}
          className="_d-flex _justify-content-end align-items-center _bg-gray-100 _py-4 _px-4"
        >
          <Button onClick={submitAction} loading={isLoading} disabled={isDisabled}>
            {i18n.t('modals.schedule_posts.buttons.save')}
          </Button>
        </PostModalFooterContainer>
      </ContainerSidebarFooter>
    </ContainerSidebar>
  </CustomSidebar>
)

export default EditPostSidebar
